/**
 * Chinese Common Translations
 * 通用翻译模块 - 中文
 * 
 * 包含导航栏 (nav) 和页脚 (footer) 的翻译
 */

import type { CommonTranslations } from '../../types';

export const zhCommon: CommonTranslations = {
  nav: {
    home: '首页',
    products: '产品中心',
    technology: '技术介绍',
    about: '关于我们',
    contact: '联系我们',
    faq: '常见问题',
  },
  footer: {
    contact: '联系我们',
    phone: '电话',
    email: '电子邮箱',
    address: '地址',
    rights: '版权所有。',
    brandDesc: '专业生产红外辐射取暖设备。自2006年以来，致力于为世界提供温暖、舒适和节能的解决方案。',
    products: '产品中心',
    support: '技术支持',
    newsletter: '订阅资讯',
    newsletterDesc: '订阅获取最新的产品更新和行业动态。',
    join: '订阅',
    catalog: '下载目录',
    emailPlaceholder: '输入您的电子邮箱',
    product1: '红外取暖器',
    product2: '便携式取暖器',
    product3: '',
    product4: '',
    privacy: '隐私政策',
    terms: '服务条款',
    sitemap: '网站地图',
    installationGuide: '安装指南',
    warrantyPolicy: '保修政策',
  },
};
